import React, { Component } from 'react'
// import { } from 'react-router-dom';
// import paypal from '../../common/img/paypal.svg';
import { connect } from 'react-redux'
import { Spinner } from 'components/Loaders/Loaders'
import {
  GET_PAYPAL_TOKEN,
  GET_ACCESSIDLOC_TOKEN,
  GET_ACCESSIDCC_TOKEN,
  GET_PAYEEZY_HASH,
  POST_PAYMENT,
  BASE_URL,
  BYPASS_PAYMENT,
  GET_AVAILABLE_PAYMENT_METHODS,
  GET_PAYROC_CUSTOMER,
  CREATE_PAYROC_TRANSACTION,
  CREATE_PAYROC_CUSTOMER_PAYMENT_SOURCE,
  DELETE_PAYROC_CUSTOMER_PAYMENT_SOURCE,
  GET_WEB_USER_ACTIVE_CART,
  GET_WEB_CART_BY_REF_NUM,
  GET_APP_SETTING_BY_NAME,
  REMOVE_FROM_WEB_CART_BY_GUID,
  WEB_CART_TRANSACTION_WITH_FREQUENT_PAYOR,
  CREATE_CYBERSOURCE_WEB_CART,
  MAKE_PAYMENT_TRANSACTION,
  WEB_CART_GUIDS_TRANSACTION_WITH_FREQUENT_PAYOR,
  SUBMIT_TT_NON_SAVED_PAYMENT,
  SUBMIT_TT_SAVED_PAYMENT,
  ADD_USER_PAYMENT_INFO,
} from 'requests'
import { setCartQuantity, setErrorToast } from '../../actions'
import { calculateReceiptItemsTotal, calculateReceiptItemContainersTotal } from 'utilities'
import LockIcon from '@tecuity/sos-icons/react/lock-solid'
import CrossIcon from '@tecuity/sos-icons/react/cross-heavy'
import CreditCardIcon from '@tecuity/sos-icons/react/credit-card-solid'
import BankIcon from '@tecuity/sos-icons/react/bank-solid'
import PlusIcon from '@tecuity/sos-icons/react/plus-heavy'
import TrashIcon from '@tecuity/sos-icons/react/trash'
import CaretLeftIcon from '@tecuity/sos-icons/react/caret-left'
import store, { history } from '../../store'
import { RadioInput } from '../Wizard2/fieldComponents/Form'
import { ConfirmDialog, Modal } from 'components/Modal/Modal'
import Portal from 'components/Portal/Portal'
import { FrequentPayorCheckoutSection } from '../FrequentPayor/FrequentPayor'
import {
  // ElavonCheckoutSection,
  ElavonProvider,
  submitElavonCheckout,
  submitElavonACHCheckout,
} from 'components/Elavon/Elavon'
import NativeCheckout from './NativeCheckout'
import './Checkout.scss'
import ReactMarkdown from '../../components/Markdown/Markdown'
import { SelectBox } from '@tecuity/granite-ui'
import TruValidate from '../TruValidate/TruValidate'
import ExclamationIcon from '@tecuity/sos-icons/react/exclamation-point'
import { PaymentusSavedPayment } from './Paymentus/PaymentusSavedPayments'
import { WalletApiSavedPayment } from './WalletApi/WalletApiSavedPayment'

const PAYMENT_BYPASS_SIMULATES_PAYPAL_CALLBACK =
  process.env.PAYMENT_BYPASS_SIMULATES_PAYPAL_CALLBACK
const SHOPPING_CART = process.env.SHOPPING_CART
const CHECKOUT_DISCLAIMER = process.env.CHECKOUT_DISCLAIMER
const PASS_ITEM_GUIDS_ON_CHECKOUT = process.env.PASS_ITEM_GUIDS_ON_CHECKOUT
const CEPAS_GUEST = process.env.CEPAS_GUEST
const CEPAS_ACCOUNT = process.env.CEPAS_ACCOUNT

class ConnectedCheckout extends Component {
  constructor() {
    super()
    this.state = {
      paymentSuccessful: false,
      loading: true,
      SECURETOKEN: '',
      SECURETOKENID: '',
      BASEPAYMENTURL: '',
      availableMethods: null,
    }
  }
  componentDidMount = () => {
    this.getAvailablePaymentMethods()
  }
  getAvailablePaymentMethods = () => {
    if (!this.props.availableMethods) {
      GET_AVAILABLE_PAYMENT_METHODS(
        (availableMethods) => {
          this.setState({ availableMethods, loading: false })
        },
        (err) => {
          this.setState({ loading: false })
        }
      )
    } else {
      this.setState({
        loading: false,
        availableMethods: { ...this.props.availableMethods, type: '' },
      })
    }
  }
  payWithCreditCard = () => {
    POST_PAYMENT(
      {
        amendmentNum: this.props.amendmentNum,
        formDefinitionId: this.props.formDefinitionId,
        correctionMode: this.props.correctionMode || false,
      },
      this.props.category,
      (response) => {
        this.props.redirectToReceipt(0)
      }
    )
  }
  render() {
    const {
      cancelCheckout,
      receiptItems = [],
      receiptItemContainers,
      refNum,
      redirectToReceipt,
      ignoreAvailability,
      onReceiptItemContainerRemoved,
      setCartQuantity,
      skipCartQuantityUpdate,
      onCartRefresh,
      frequentPayorAddFundsCart = false,
    } = this.props
    const total = receiptItemContainers
      ? calculateReceiptItemContainersTotal(receiptItemContainers)
      : calculateReceiptItemsTotal(receiptItems)

    return (
      <React.Fragment>
        <TruValidate>
          <Checkout
            onRequestModalClose={cancelCheckout}
            receiptItems={receiptItems}
            receiptItemContainers={receiptItemContainers}
            total={total}
            refNum={refNum}
            payWithCreditCard={this.payWithCreditCard}
            redirectToReceipt={(refNum) => {
              redirectToReceipt(refNum)
              if (!skipCartQuantityUpdate) {
                setCartQuantity(0)
              }
            }}
            loading={this.state.loading}
            availableMethods={this.state.availableMethods}
            ignoreAvailability={ignoreAvailability}
            onReceiptItemContainerRemoved={onReceiptItemContainerRemoved}
            onCartRefresh={onCartRefresh}
            frequentPayorAddFundsCart={frequentPayorAddFundsCart}
            TruValidateIsEnabled={this.props.TruValidateIsEnabled}
            TruValidateRequest={this.props.TruValidateRequest}
            userId={this.props.userId}
          />
        </TruValidate>
      </React.Fragment>
    )
  }
}

export default connect(
  (state) => ({
    TruValidateIsEnabled: state.app.appSettings.TruValidateIsEnabled || false,
    TruValidateRequest: state.auth.truValidateRequest,
    userId: state.auth.WEB_USER_ID,
  }),
  { setCartQuantity }
)(ConnectedCheckout)

export class Checkout extends React.Component {
  constructor() {
    super()
    this.iFrameRef = React.createRef()
  }
  state = {
    paymentClicked: false,
    paypalParams: { SECURETOKEN: '', SECURETOKENID: '', BASEPAYMENTURL: '', PAYMENT_URL: '' },
    payeezyParams: { x_amount: 0, x_fp_timestamp: '', x_fp_hash: '', x_invoice_num: '' },
    prePaymentError: false,
    prePaymentErrorMessage: null,
    iTransactIsLoaded: true,
    deletedGuids: [],
    nativeCheckoutActive: false,
    nativeError: null,
    payeezyPageName: null,
    payeezyUrl: null,
    selectedMethod: [],
    isUsingACH: process.env.CCP_WITH_ACH !== undefined ? process.env.CCP_WITH_ACH : true,
    isACHType: false,
    isCCPIFrameOpened: false,
    iFrameSource: null,
    walletId: null,
    ccpPaymentButtonClicked: false,
    removeWebItemError: ''
  }
  componentDidMount = () => {
    //this.iFrameRef.current && this.iFrameRef.current.document.addEventListener('message', this.handleMessage);
    window.addEventListener('message', this.handleMessage)
  }

  componentWillUnmount = () => {
    window.removeEventListener('message', this.handleMessage)
  }
  componentDidUpdate = (prevProps, prevState) => {
    if (
      process.env.FREQUENT_PAYOR_ACH_ONLY &&
      this.isPayeezyEnabled() &&
      !this.props.payeezyPageName &&
      this.state.payeezyPageName === null
    ) {
      this.loadAppSettings(this.props.frequentPayorAddFundsCart)
    }
    if (this.props.availableMethods !== prevProps.availableMethods){
      if (this.isCyberSourceEnabled()) {
        this.loadCyberSourceAPIBaseURL()
      }
      if (this.isPayeezyEnabled()) {
        this.loadPayeezyUrl()
      }
    }
  }

  handleMessage = (event) => {
    // check request is from legitimate source and message is expected or not
    if (
      event.origin !== 'https://microservices-uat.cdc.nicusa.com' &&
      event.origin !== 'https://microservices.cdc.nicusa.com'
    ) {
      return
    }

    // Wallet API IFrame messages (PaymentAccountAdded / PaymentAccountCached /
    // Cancel) are now owned by the WalletApiSavedPayment component, which keeps
    // its own scoped listener. Handling them here too would double-charge.
    window.ALLOW_BYPASS_WIZARD_PROMPT = true
  }
  isPayeezyEnabled = () => {
    return (this.props.availableMethods || []).some((method) => method.ProviderType === 'payeezy')
  }
  isCyberSourceEnabled = () => {
    return (this.props.availableMethods || []).some((method) => method.ProviderType === 'cyberSource')
  }

  loadPayeezyUrl = () => {
    GET_APP_SETTING_BY_NAME('PAYEEZY_CHECKOUT_URL', (res) => {
      this.setState({
        payeezyUrl: res.VALUE,
      })
    })
  }
  loadAppSettings = (isAdding) => {
    if (isAdding) {
      GET_APP_SETTING_BY_NAME('PAYEEZY_ACH_PAYMENT_PAGE_NAME', (res) => {
        this.setState({
          payeezyPageName: res.VALUE,
        })
      })
    } else {
      GET_APP_SETTING_BY_NAME('PAYEEZY_CC_PAYMENT_PAGE_NAME', (res) => {
        this.setState({
          payeezyPageName: res.VALUE,
        })
      })
    }
  }
  buildTruValidateInfo = (type) => {
    return {
      ...this.props.TruValidateRequest,
      userId: this.props.userId,
      Type: type,
      TransactionInsight: {
        refNum: this.props.refNum,
        total: this.props.rawTotal,
        items: this.props.receiptItems,
      },
    }
  }

  getPaypalToken = () => {
    GET_PAYPAL_TOKEN(
      this.props.refNum,
      null,
      ({ SECURETOKEN, SECURETOKENID, BASEPAYMENTURL, PAYMENT_URL }) => {
        this.setState(
          {
            paypalParams: {
              SECURETOKEN,
              SECURETOKENID,
              BASEPAYMENTURL,
              PAYMENT_URL,
            },
          },
          () => {
            this.paypalSubmit.click()
          }
        )
      },
      (err) => {
        this.setState({
          prePaymentError: true,
          paymentClicked: false,
          prePaymentErrorMessage: err.message,
        })
      }
    )
  }
  getPayeezyHash = (values) => {
    GET_PAYEEZY_HASH(
      PASS_ITEM_GUIDS_ON_CHECKOUT
        ? {
            ITEMIDS: this.getFilteredReceiptItemContainers(this.props.receiptItemContainers).map(
              (container) => container.GUID
            ),
            payload: values,
          }
        : {
            SECURETOKENID: this.props.refNum,
          },
      ({ x_amount, x_fp_timestamp, x_fp_hash, x_invoice_num }) => {
        this.setState(
          {
            payeezyParams: {
              x_amount,
              x_fp_timestamp,
              x_fp_hash,
              x_invoice_num,
            },
          },
          () => {
            this.payeezySubmit.click()
          }
        )
      },
      (err) => {
        this.setState({
          prePaymentError: true,
          paymentClicked: false,
          prePaymentErrorMessage: err.message,
        })
      }
    )
  }
  getAccessIDCCToken = () => {
    GET_ACCESSIDCC_TOKEN(
      this.props.refNum,
      ({ SECURETOKEN, SECURETOKENID, BASEPAYMENTURL }) => {
        this.setState(
          {
            paypalParams: {
              SECURETOKEN,
              SECURETOKENID,
              BASEPAYMENTURL,
            },
          },
          () => {
            this.accessIDCCSubmit.click()
          }
        )
      },
      (err) => {
        this.setState({
          prePaymentError: true,
          paymentClicked: false,
          prePaymentErrorMessage: err.message,
        })
      }
    )
  }
  getAccessIDLOCToken = () => {
    GET_ACCESSIDLOC_TOKEN(
      this.props.refNum,
      ({ SECURETOKEN, SECURETOKENID, BASEPAYMENTURL }) => {
        this.setState(
          {
            paypalParams: {
              SECURETOKEN,
              SECURETOKENID,
              BASEPAYMENTURL,
            },
          },
          () => {
            this.accessIDLOCSubmit.click()
          }
        )
      },
      (err) => {
        this.setState({
          prePaymentError: true,
          paymentClicked: false,
          prePaymentErrorMessage: err.message,
        })
      }
    )
  }

  payWithElevonPage = (values) => {
    CREATE_CYBERSOURCE_WEB_CART(
      {
        ITEMIDS: this.getFilteredReceiptItemContainers(this.props.receiptItemContainers).map(
          (container) => container.GUID
        ),
        //riskCheckInfo,
      },
      (webCartNum) => {
        localStorage.setItem('webCartNum', webCartNum)
        MAKE_PAYMENT_TRANSACTION(
          {
            webCartNum: webCartNum,
            paymentType: 'card',
            achType: '',
            //riskCheckInfo,
          },
          (response) => {
            window.location.href = `https://api.demo.convergepay.com/hosted-payments?ssl_txn_auth_token=${encodeURIComponent(response["token"])}`
          },
          (err) => {
            console.error(err)
          }
        )
      },
      (err) => {
        this.setState({
          prePaymentError: true,
          prePaymentErrorMessage: err.message,
          paymentClicked: false,
        })
        console.error(err)
      }
    )
  }

  submitElavonCheckout = (values) => {
    submitElavonCheckout(
      values,
      PASS_ITEM_GUIDS_ON_CHECKOUT
        ? this.getFilteredReceiptItemContainers(this.props.receiptItemContainers).map(
            (container) => container.GUID
          )
        : this.props.refNum
    )
      .then(this.props.redirectToReceipt)
      .catch((err) => {
        this.setState({
          paymentClicked: false,
          nativeError: (
            <React.Fragment>
              {err.errorCode ? <strong>{err.errorCode} -</strong> : null}
              {err.errorMessage ||
                err.message ||
                'Something went wrong while processing this payment. Please try again later.'}
            </React.Fragment>
          ),
        })
      })
  }

  submitElavonACHCheckout = (values) => {
    submitElavonACHCheckout(
      values,
      PASS_ITEM_GUIDS_ON_CHECKOUT
        ? this.getFilteredReceiptItemContainers(this.props.receiptItemContainers).map(
            (container) => container.GUID
          )
        : this.props.refNum
    )
      .then(this.props.redirectToReceipt)
      .catch((err) => {
        this.setState({
          paymentClicked: false,
          nativeError: (
            <React.Fragment>
              {err.errorCode ? <strong>{err.errorCode} -</strong> : null}
              {err.errorMessage ||
                err.message ||
                'Something went wrong while processing this payment. Please try again later.'}
            </React.Fragment>
          ),
        })
      })
  }
  startPayment = (method) => {
    this.setState({ paymentClicked: true })
    method()
  }
  loadCyberSourceAPIBaseURL = () => {
    GET_APP_SETTING_BY_NAME('CYBERSOURCE_API_BAS_URL', (res) => {
      this.setState({
        cybersourceURL: res.VALUE,
      })
    })
  }
  payWithCepas = () => {
    let riskCheckInfo = null
    if (this.props.TruValidateIsEnabled) {
      riskCheckInfo = this.buildTruValidateInfo('Cepas')
    }
    CREATE_CYBERSOURCE_WEB_CART(
      {
        ITEMIDS: this.getFilteredReceiptItemContainers(this.props.receiptItemContainers).map(
          (container) => container.GUID
        ),
        riskCheckInfo,
      },
      (webCartNum) => {
        localStorage.setItem('webCartNum', webCartNum)
        MAKE_PAYMENT_TRANSACTION(
          {
            webCartNum: webCartNum,
            paymentType: 'card',
            achType: '',
            riskCheckInfo,
          },
          (response) => {
            window.location.href = response
          },
          (err) => {
            console.error(err)
          }
        )
      },
      (err) => {
        this.setState({
          prePaymentError: true,
          prePaymentErrorMessage: err.message,
          paymentClicked: false,
        })
        console.error(err)
      }
    )
  }

  payWithCepasAccount = () => {
    let riskCheckInfo = null
    if (this.props.TruValidateIsEnabled) {
      riskCheckInfo = this.buildTruValidateInfo('CepasAccount')
    }
    CREATE_CYBERSOURCE_WEB_CART(
      {
        ITEMIDS: this.getFilteredReceiptItemContainers(this.props.receiptItemContainers).map(
          (container) => container.GUID
        ),
        riskCheckInfo,
      },
      (webCartNum) => {
        localStorage.setItem('webCartNum', webCartNum)
        MAKE_PAYMENT_TRANSACTION(
          {
            webCartNum: webCartNum,
            paymentType: 'card',
            achType: '',
            useCepasAccount: true,
            riskCheckInfo,
          },
          (response) => {
            window.location.href = response
          },
          (err) => {
            console.error(err)
          }
        )
      },
      (err) => {
        this.setState({
          prePaymentError: true,
          prePaymentErrorMessage: err.message,
          paymentClicked: false,
        })
        console.error(err)
      }
    )
  }

  payWithPaymentusOneTimePayment = () => {
    let riskCheckInfo = null
    if (this.props.TruValidateIsEnabled) {
      riskCheckInfo = this.buildTruValidateInfo('Paymentus')
    }
    CREATE_CYBERSOURCE_WEB_CART(
        {
            ITEMIDS: this.getFilteredReceiptItemContainers(this.props.receiptItemContainers).map((container) => container.GUID),
            riskCheckInfo,
        },
        (webCartNum) => {
            localStorage.setItem('webCartNum', webCartNum)
            MAKE_PAYMENT_TRANSACTION(
                {
                    webCartNum: webCartNum,
                    paymentType: 'card',
                    achType: '',
                    riskCheckInfo,
                },
                (resp) => {
                    window.location.href = resp
                },
                (err) => {
                    console.error(err)
                }
            )
        },
        (err) => {
            console.error(err)
        }
    )
  }

  payWithCyberSource = ({ paymentType, achType }) => {
    let riskCheckInfo = null
    if (this.props.TruValidateIsEnabled) {
      riskCheckInfo = this.buildTruValidateInfo('CyberSource')
    }
    CREATE_CYBERSOURCE_WEB_CART(
      {
        ITEMIDS: this.getFilteredReceiptItemContainers(this.props.receiptItemContainers).map(
          (container) => container.GUID
        ),
        riskCheckInfo,
      },
      (webCartNum) => {
        localStorage.setItem('webCartNum', webCartNum)
        MAKE_PAYMENT_TRANSACTION(
          {
            webCartNum: webCartNum,
            paymentType: paymentType,
            achType: achType || '',
          },
          (res) => {
            let cyberSourceForm = document.createElement('form')
            cyberSourceForm.setAttribute('action', this.state.cybersourceURL + 'pay')
            cyberSourceForm.setAttribute('method', 'POST')

            Object.entries(res).map(([k, v]) => {
              const input = document.createElement('input')
              input.setAttribute('type', 'hidden')
              input.setAttribute('id', k)
              input.setAttribute('name', k)
              input.setAttribute('value', v)
              cyberSourceForm.appendChild(input)
              return null
            })
            document.body.appendChild(cyberSourceForm)
            cyberSourceForm.submit()
            //this.props.redirectToReceipt(webCartNum)
          },
          (err) => {
            this.setState({
              prePaymentError: true,
              prePaymentErrorMessage: err.message,
              paymentClicked: false,
            })
            console.error(err)
          }
        )
      },
      (err) => {
        this.setState({
          prePaymentError: true,
          prePaymentErrorMessage: err.message,
          paymentClicked: false,
        })
        console.error(err)
      }
    )
  }

  //CCP is AR's payment provider.
  payWithCCPSource = ({ paymentType, achType }) => {
    CREATE_CYBERSOURCE_WEB_CART(
      {
        ITEMIDS: this.getFilteredReceiptItemContainers(this.props.receiptItemContainers).map(
          (container) => container.GUID
        ),
      },
      (webCartNum) => {
        MAKE_PAYMENT_TRANSACTION(
          {
            webCartNum: webCartNum,
            paymentType: paymentType,
            achType: achType || '',
          },
          (res) => {
            window.location.href = res.html5RedirectURL
          },
          (error) => {
            this.setState({
              prePaymentError: true,
              prePaymentErrorMessage: error.message,
              paymentClicked: false,
            })
            store.dispatch(setErrorToast(error))
            console.error('Error from MAKE_PAYMENT_TRANSACTION: ', error)
          }
        )
      },
      (err) => {
        this.setState({
          prePaymentError: true,
          prePaymentErrorMessage: err.message,
          paymentClicked: false,
        })
        store.dispatch(setErrorToast(err))
        console.error('Error from CREATE_CYBERSOURCE_WEB_CART: ', err)
      }
    )
  }

  //CCP is AR's payment provider.
  payWithWalletAPISource = ({ paymentType, achType }) => {
    CREATE_CYBERSOURCE_WEB_CART(
      {
        ITEMIDS: this.getFilteredReceiptItemContainers(this.props.receiptItemContainers).map(
          (container) => container.GUID
        ),
      },
      (webCartNum) => {
        localStorage.setItem('webCartNum', webCartNum)
        MAKE_PAYMENT_TRANSACTION(
          {
            webCartNum: webCartNum,
            paymentType: paymentType,
            achType: 'TBD',
          },
          (res) => {
            this.setState({
              isCCPIFrameOpened: true,
              paymentClicked: false,
              iFrameSource: res.iFrameSource,
              walletId: res.walletId,
            })
          },
          (error) => {
            this.setState({
              prePaymentError: true,
              prePaymentErrorMessage: error.message,
              paymentClicked: false,
            })
            console.error('Error: ', error)
          }
        )
      },
      (err) => {
        this.setState({
          prePaymentError: true,
          prePaymentErrorMessage: err.message,
          paymentClicked: false,
        })
        store.dispatch(setErrorToast(err))
        console.error(err)
      }
    )
  }

  submitTTNonSavedPaymnent = () => {
    //Will remove later, need it now for debugging
    SUBMIT_TT_NON_SAVED_PAYMENT(
      localStorage.getItem('webCartNum'),
      (response) => {
        this.setState({
          isCCPIFrameOpened: false,
          iFrameSource: null,
          paymentClicked: false,
          ccpPaymentButtonClicked: false,
        })
        //eventually need to make a call to validate the request.
        history.push(`/processpayment/walletapinonsaved/?ref=${localStorage.getItem('webCartNum')}`)
      },
      (err) => {
        this.setState({
          prePaymentError: true,
          prePaymentErrorMessage: err.message,
          paymentClicked: false,
        })
        store.dispatch(setErrorToast(err))
        console.error(err)
      }
    )
  }

  submitTTSavedPaymnent = (userPaymentInfo) => {
    //Will remove later, need it now for debugging
    console.log('calling SUBMIT_TT_SAVED_PAYMENT')
    SUBMIT_TT_SAVED_PAYMENT(
      localStorage.getItem('webCartNum'),
      userPaymentInfo,
      null, // no Nacha agreement for this flow
      (response) => {
        this.setState({
          isCCPIFrameOpened: false,
          iFrameSource: null,
          paymentClicked: false,
          ccpPaymentButtonClicked: false,
        })
        //eventually need to make a call to validate the request.
        history.push(`/processpayment/walletapisaved/?ref=${localStorage.getItem('webCartNum')}`)
      },
      (err) => {
        this.setState({
          prePaymentError: true,
          prePaymentErrorMessage: err.message,
          paymentClicked: false,
        })
        store.dispatch(setErrorToast(err))
        console.error(err)
      }
    )
  }

  addUserPaymentInfo = () => {
    //Will remove later, need it now for debugging
    console.log('calling ADD_USER_PAYMENT_INFO')
    ADD_USER_PAYMENT_INFO(
      this.state.walletId,
      (response) => {
        //eventually submit saved-payment here
        console.log('call SubmitV2Payment')
        this.setState({ ccpPaymentButtonClicked: true });
        this.submitTTSavedPaymnent(response)
      },
      (err) => {
        this.setState({
          prePaymentError: true,
          prePaymentErrorMessage: err.message,
          paymentClicked: false,
        })
        store.dispatch(setErrorToast(err))
        console.error(err)
      }
    )
  }

  bypassPayment = () => {
    let riskCheckInfo = null
    if (this.props.TruValidateIsEnabled) {
      riskCheckInfo = this.buildTruValidateInfo('BypassPayment')
    }
    BYPASS_PAYMENT(
      PASS_ITEM_GUIDS_ON_CHECKOUT
        ? {
            ITEMIDS: this.getFilteredReceiptItemContainers(this.props.receiptItemContainers).map(
              (container) => container.GUID
            ),
            riskCheckInfo,
          }
        : {
            SECURETOKENID: this.props.refNum,
            riskCheckInfo,
          },
      (refNum) => {
        if (PAYMENT_BYPASS_SIMULATES_PAYPAL_CALLBACK) {
          window.ALLOW_BYPASS_WIZARD_PROMPT = true
          history.push(`/processpayment/paypal?SECURETOKENID=${refNum || this.props.refNum}`)
        } else {
          this.props.redirectToReceipt(refNum)
        }
      },
      (err) => {
        this.setState({
          prePaymentError: true,
          prePaymentErrorMessage: err.message,
          paymentClicked: false,
        })
        console.error(err)
      }
    )
  }
  payWithFrequentPayor = () => {
    if (PASS_ITEM_GUIDS_ON_CHECKOUT) {
      WEB_CART_GUIDS_TRANSACTION_WITH_FREQUENT_PAYOR(
        {
          ITEMIDS: this.getFilteredReceiptItemContainers(this.props.receiptItemContainers).map(
            (container) => container.GUID
          ),
        },
        (refNum) => {
          this.props.redirectToReceipt(refNum)
        },
        (err) => {
          this.setState({
            prePaymentError: true,
            prePaymentErrorMessage: err.message,
            paymentClicked: false,
          })
          console.error(err)
        }
      )
    } else {
      WEB_CART_TRANSACTION_WITH_FREQUENT_PAYOR(
        this.props.refNum,
        () => {
          this.props.redirectToReceipt()
        },
        (err) => {
          this.setState({
            prePaymentError: true,
            prePaymentErrorMessage: err.message,
            paymentClicked: false,
          })
          console.error(err)
        }
      )
    }
  }
  setTransactLoaded = () => this.setState({ iTransactIsLoaded: true })
  registerSubmodule = (module) =>
    this.setState((state) => ({ registeredSubmodules: [...state.registeredSubmodules, module] }))
  removeItemFromCart = (guid) => {
    const deletedGuids = this.state.deletedGuids
    REMOVE_FROM_WEB_CART_BY_GUID(
      guid,
      (webCart) => {
        this.setState((state) => ({
          deletedGuids: [...state.deletedGuids, guid],
        }))
        if (webCart.STATUS_ID == '132' && webCart.WEB_CART_ID > 0)
          history.push(`/receipt?ref=${webCart.REF_NUM}`)
        this.props.setCartQuantity(this.getNumReceiptItemContainers())
        if (typeof this.props.onCartRefresh === 'function') {
          this.props.onCartRefresh()
        }
        if (typeof this.props.onReceiptItemContainerRemoved === 'function') {
          this.props.onReceiptItemContainerRemoved(guid)
        }
      },
      (err) => {
        console.error(err)
        this.setState({removeWebItemError: err})
        if (typeof this.props.onCartRefresh === 'function') {
          this.props.onCartRefresh()
        } else {
          this.setState({ deletedGuids })
        }
      }
    )
  }
  getFilteredReceiptItemContainers = (items) =>
    items ? items.filter((x) => !this.state.deletedGuids.includes(x.GUID)) : []
  getNumReceiptItemContainers = () =>
    this.getFilteredReceiptItemContainers(
      this.props.receiptItemContainers.filter((x) => !x.IS_FREE)
    ).length
  setPrepaymentError = (prePaymentError) => this.setState({ prePaymentError })
  nativeCheckoutCallbackHandler = null

  registerNativeCallbackHandler = (handler) => {
    if (typeof handler !== 'function') {
      throw new Error('The handler you attempted to register is not a function.')
    } else {
      this.nativeCheckoutCallbackHandler = handler
    }
  }

  handleNativeCallback = (values) => {
    this.setState({ paymentClicked: true, nativeError: null })
    this.nativeCheckoutCallbackHandler(values)
  }
  render() {
    const {
      receiptItems = [],
      receiptItemContainers: allReceiptItemContainers,
      total: rawTotal = 0,
      onRequestModalClose,
      loading,
      availableMethods,
      refNum,
      ignoreAvailability,
      isFrequentPayor,
      loggedIn,
      frequentPayorAddFundsCart = false,
    } = this.props
    const receiptItemContainers = this.getFilteredReceiptItemContainers(allReceiptItemContainers)
    const hasRenderableItems = allReceiptItemContainers
      ? !!receiptItemContainers.length
      : !!receiptItems.length
    let total = rawTotal
    if (receiptItemContainers.length < (allReceiptItemContainers || []).length) {
      total = calculateReceiptItemContainersTotal(receiptItemContainers)
    }
    const paymentButtonsDisabled = this.state.paymentClicked || this.state.nativeCheckoutActive
    const displayShoppingCart = SHOPPING_CART === true && loggedIn === true

    let { isUsingACH } = this.state

    const getPaymentMethodsJSX = (method) => {
      switch (method.ProviderType) {
        case 'paypal':
          return (
            <form
              method="POST"
              action={this.state.paypalParams.PAYMENT_URL}
              key={method.ProviderType + 'frm'}
            >
              <input
                type="hidden"
                name="SECURETOKENID"
                value={this.state.paypalParams.SECURETOKENID}
                readOnly
              />
              <input
                type="hidden"
                name="SECURETOKEN"
                value={this.state.paypalParams.SECURETOKEN}
                readOnly
              />
              <input type="hidden" name="ECHODATA" value="user" readOnly />
              <input
                type="hidden"
                name="USER1"
                value={JSON.stringify({
                  ORIGIN: BASE_URL,
                  BASE_URL,
                  ENV: process.env.NODE_ENV,
                })}
                readOnly
              />
              <PaymentButton
                onClick={() => {
                  this.startPayment(this.getPaypalToken)
                }}
                disabled={paymentButtonsDisabled}
                error={this.state.prePaymentError}
              >
                Pay with Credit Card
                {/* <img src={paypal} alt='Pay with Paypal'/> */}
              </PaymentButton>
              <button
                ref={(r) => {
                  this.paypalSubmit = r
                }}
                style={{ display: 'none' }}
                type="submit"
              />
            </form>
          )
        case 'payeezy':
          return (
            <React.Fragment>
              {!this.state.payeezyUrl ? (
                <Spinner color="#7792d0" className="checkout-loader" size="small" />
              ) : (
                <form method="POST" action={this.state.payeezyUrl} key={method.ProviderType + 'frm'}>
                  <input name="x_login" value={this.state.payeezyPageName} type="hidden" />

                  <input name="x_amount" value={this.state.payeezyParams.x_amount} type="hidden" />

                  <input name="x_fp_sequence" value="123456" type="hidden" />

                  <input
                    name="x_fp_timestamp"
                    value={this.state.payeezyParams.x_fp_timestamp}
                    type="hidden"
                  />

                  <input
                    name="x_fp_hash"
                    value={this.state.payeezyParams.x_fp_hash}
                    type="hidden"
                  />

                  <input
                    name="x_invoice_num"
                    value={this.state.payeezyParams.x_invoice_num}
                    type="hidden"
                  />

                  <input name="x_show_form" value="PAYMENT_FORM" type="hidden" />

                  <PaymentButton
                    onClick={() => {
                      this.startPayment(
                        this.getPayeezyHash({
                          x_fp_sequence: '123456',
                          x_login: this.state.payeezyPageName,
                          ach_payment_yn: frequentPayorAddFundsCart ? true : false,
                        })
                      )
                    }}
                    disabled={paymentButtonsDisabled}
                    error={this.state.prePaymentError}
                  >
                    {frequentPayorAddFundsCart ? 'Pay with ACH' : 'Pay with credit or debit card'}
                  </PaymentButton>
                  <button
                    ref={(r) => {
                      this.payeezySubmit = r
                    }}
                    style={{ display: 'none' }}
                    type="submit"
                  />
                </form>
              )}
            </React.Fragment>
          )
        case 'accessIDCC':
          return (
            <React.Fragment>
              <form
                method="POST"
                action={this.state.paypalParams.BASEPAYMENTURL}
                key={method.ProviderType + 'frm'}
              >
                <PaymentButton
                  onClick={() => {
                    this.startPayment(this.getAccessIDCCToken)
                  }}
                  disabled={paymentButtonsDisabled}
                  error={this.state.prePaymentError}
                >
                  Pay with Credit Card
                </PaymentButton>
                <button
                  ref={(r) => {
                    this.accessIDCCSubmit = r
                  }}
                  style={{ display: 'none' }}
                  type="submit"
                />
              </form>
            </React.Fragment>
          )
        case 'accessIDLOC':
          return (
            <form
              method="POST"
              action={this.state.paypalParams.BASEPAYMENTURL}
              key={method.ProviderType + 'frm'}
            >
              <PaymentButton
                onClick={() => {
                  this.startPayment(this.getAccessIDLOCToken)
                }}
                disabled={paymentButtonsDisabled}
                error={this.state.prePaymentError}
              >
                Pay with Access Idaho
              </PaymentButton>
              <button
                ref={(r) => {
                  this.accessIDLOCSubmit = r
                }}
                style={{ display: 'none' }}
                type="submit"
              />
            </form>
          )
        case 'iTransact':
          return (
            <form key="iTransact">
              <ITransact
                refNum={refNum}
                onComplete={this.props.redirectToReceipt}
                receiptItemGuids={this.getFilteredReceiptItemContainers(
                  this.props.receiptItemContainers
                ).map((container) => container.GUID)}
              />
            </form>
          )
        case 'bypass':
          return (
            <PaymentButton
              onClick={() => {
                this.startPayment(this.bypassPayment)
              }}
              error={this.state.prePaymentError}
              disabled={paymentButtonsDisabled}
              key={method.ProviderType}
            >
              Bypass Checkout (Dev-only)
            </PaymentButton>
          )
        case 'frequentPayor':
          return isFrequentPayor && !frequentPayorAddFundsCart ? (
            <FrequentPayorCheckoutSection
              key={method.ProviderType}
              total={total}
              disabled={paymentButtonsDisabled}
              error={this.state.prePaymentError}
              errorMessage={this.state.prePaymentErrorMessage}
              onPaymentRequested={() => this.startPayment(this.payWithFrequentPayor)}
            />
          ) : null
        case 'cepas':
          return (
            <React.Fragment key={method.ProviderType}>
              <PaymentButton
                onClick={() => {
                  this.startPayment(() => this.payWithCepas({ paymentType: 'card' }))
                }}
                error={this.state.prePaymentError}
                disabled={paymentButtonsDisabled}
              >
                {CEPAS_GUEST || 'CEPAS Guest Checkout'}
              </PaymentButton>
              <PaymentButton
                onClick={() => {
                  this.startPayment(() => this.payWithCepasAccount({ paymentType: 'card' }))
                }}
                error={this.state.prePaymentError}
                disabled={paymentButtonsDisabled}
              >
                {CEPAS_ACCOUNT || 'Pay using CEPAS Account'}
              </PaymentButton>
            </React.Fragment>
          )
        case 'PaymentusOneTimePayment':
            return (
                <React.Fragment key={method.ProviderType}>
                    <PaymentButton
                        onClick={() => {
                            this.startPayment(this.payWithPaymentusOneTimePayment);
                        }}
                        disabled={paymentButtonsDisabled}
                        error={this.state.prePaymentError}
                    >
                        Pay with Paymentus
                    </PaymentButton>
                </React.Fragment>
            )
        case 'PaymentusSavedPayment' :
             return (
                <PaymentusSavedPayment 
                  ProviderType={method.ProviderType}
                  startPayment={this.startPayment}
                  redirectToReceipt={this.props.redirectToReceipt}
                  receiptItemGuids={this.getFilteredReceiptItemContainers(
                  this.props.receiptItemContainers
                ).map((container) => container.GUID)}/>
            )
        case 'cyberSource':
          return (
            <React.Fragment key={method.ProviderType}>
              <PaymentButton
                onClick={() => {
                  this.startPayment(() => this.payWithCyberSource({ paymentType: 'card' }))
                }}
                error={this.state.prePaymentError}
                disabled={paymentButtonsDisabled}
              >
                Pay with Credit or Debit Card
              </PaymentButton>
              <PaymentButton
                onClick={() => {
                  this.startPayment(() =>
                    this.payWithCyberSource({ paymentType: 'ach', achType: 'PPD' })
                  )
                }}
                error={this.state.prePaymentError}
                disabled={paymentButtonsDisabled}
              >
                Pay with Personal ACH
              </PaymentButton>
              <PaymentButton
                onClick={() => {
                  this.startPayment(() =>
                    this.payWithCyberSource({ paymentType: 'ach', achType: 'CCD' })
                  )
                }}
                error={this.state.prePaymentError}
                disabled={paymentButtonsDisabled}
              >
                Pay with Business ACH
              </PaymentButton>
            </React.Fragment>
          )
        case 'ccp':
          const ccp_payment_label = isUsingACH
            ? 'Pay with Card or ACH'
            : 'Pay with Credit or Debit Card'
          return (
            <React.Fragment key={method.ProviderType}>
              <PaymentButton
                onClick={() => {
                  this.startPayment(() => this.payWithCCPSource({ paymentType: 'card' }))
                }}
                error={this.state.prePaymentError}
                disabled={paymentButtonsDisabled}
                disableErrorHandling={true}
                bypassLoadingStyles
              >
                {ccp_payment_label}
              </PaymentButton>
            </React.Fragment>
          )
        case 'walletapi':
          return (
            <WalletApiSavedPayment
              key={method.ProviderType}
              ProviderType={method.ProviderType}
              startPayment={this.startPayment}
              receiptItemGuids={this.getFilteredReceiptItemContainers(
                this.props.receiptItemContainers
              ).map((container) => container.GUID)}
              isUsingACH={isUsingACH}
            />
          )
        case 'elavonPage':
          return(
            <PaymentButton
                onClick={() => {
                  this.startPayment(() => this.payWithElevonPage({ paymentType: 'card' }))
                }}
                error={this.state.prePaymentError}
                disabled={paymentButtonsDisabled}
              >
                Pay with Credit or Debit Card
              </PaymentButton>);
        case 'elavon':
          return (
            <form key="elavon">
                <ElavonProvider method="checkout">
                  {(elavonLoaded) => (
                    <React.Fragment>
                      { 
                      // (method.transactionTypes || []).find(
                      //   (trans) => trans.toLowerCase() == 'card'
                      // ) && (
                        <PaymentButton
                          bypassLoadingStyles
                          onClick={() => {
                            this.registerNativeCallbackHandler(this.submitElavonCheckout)
                            this.setState({ nativeCheckoutActive: true, isACHType: false })
                          }}
                          disabled={paymentButtonsDisabled || !elavonLoaded}
                          error={this.state.prePaymentError}
                          icon={<CreditCardIcon />}
                        >
                          Pay with Credit Card
                        </PaymentButton>
                      // )
                      }
                      {
                      // (method.transactionTypes || []).find(
                      //   (trans) => trans.toLowerCase() == 'ach'
                      // ) && (
                      //   <PaymentButton
                      //     bypassLoadingStyles
                      //     onClick={() => {
                      //       this.registerNativeCallbackHandler(this.submitElavonACHCheckout)
                      //       this.setState({ nativeCheckoutActive: true, isACHType: true })
                      //     }}
                      //     disabled={paymentButtonsDisabled || !elavonLoaded}
                      //     error={this.state.prePaymentError}
                      //     icon={<BankIcon />}
                      //   >
                      //     Pay with ACH
                      //   </PaymentButton>
                      // )
                      }
                    </React.Fragment>
                  )}
                </ElavonProvider>
            </form>
          )
      }
    }

    return (
      <div className="checkout" aria-busy={loading}>
        <div className="header">
          <span className="icon icon-cart" />
          <span className="title">{displayShoppingCart ? 'Cart' : 'Checkout'}</span>
          <button
            type="button"
            className={`close ${displayShoppingCart ? 'close-text' : ''}`}
            onClick={!this.state.paymentClicked ? onRequestModalClose : null}
            disabled={this.state.paymentClicked}
          >
            {displayShoppingCart ? 'Close Cart' : <span className="icon icon-cross" />}
          </button>
        </div>
        {loading ? (
          <Spinner color="#7792d0" className="checkout-loader" size="small" />
        ) : (
          <NativeCheckout
            active={this.state.nativeCheckoutActive}
            disabled={this.state.paymentClicked}
            error={this.state.nativeError}
            processing={this.state.paymentClicked}
            onDeactivateRequested={() => this.setState({ nativeCheckoutActive: false })}
            onSubmit={this.handleNativeCallback}
            isACHType={this.state.isACHType}
          >
            <React.Fragment>
              <div className="line-items">
                {allReceiptItemContainers ? (
                  receiptItemContainers.length ? (
                    receiptItemContainers.map((itemContainer, i) =>
                      !itemContainer.IS_FREE ? (
                        <ItemContainer
                          mainItem={itemContainer.RECEIPT_ITEM_WEB_LIST[0]}
                          receiptItems={itemContainer.RECEIPT_ITEM_WEB_LIST.slice(1)}
                          onRemoveRequested={() => this.removeItemFromCart(itemContainer.GUID)}
                          disabled={paymentButtonsDisabled}
                          key={itemContainer.GUID}
                        />
                      ) : null
                    )
                  ) : (
                    <p className="cart-empty-hint">There are no items in your cart</p>
                  )
                ) : receiptItems.length ? (
                  receiptItems.map((item, i) => (
                    <LineItem
                      product={item.DESCR_DISPLAY ? item.DESCR_DISPLAY : item.DESCR}
                      price={item.LINE_TOTAL.toFixed(2)}
                      key={item.REF_NUM.toString() + i}
                    />
                  ))
                ) : (
                  <p className="cart-empty-hint">There are no items in your cart</p>
                )}
              </div>
              {this.state.removeWebItemError && (
                <p className="method-error" role="alert"><ExclamationIcon /> {this.state.removeWebItemError}</p>
              )}
              {hasRenderableItems ? (
                <div className="subtotals">
                  <SubTotal label="Total:" price={`$${Number(total).toFixed(2)}`} total={true} />
                </div>
              ) : null}
              {this.state.prePaymentErrorMessage && (
                <p className="method-error" role="alert"><ExclamationIcon /> {this.state.prePaymentErrorMessage}</p>
              )}
              {hasRenderableItems ? (
                availableMethods !== null ? (
                  process.env.USE_PAYMENT_TYPE_DROPDOWN ? (
                    <div style={{ fontSize: '0.8em' }}>
                      <h5>Pay with:</h5>
                      <SelectBox
                        customCss={{ padding: '10px 0 20px 0' }}
                        options={availableMethods
                          .filter((method) => !isFrequentPayor && method.ProviderType !== 'frequentPayor' && method.DisabledErrorMessage !== null)
                          .map((method) => ({
                            label:
                              method.ProviderType === 'elavon' ||
                              method.ProviderType === 'elavonPage' ||
                              method.ProviderType === 'cyberSource' ||
                              method.ProviderType === 'payeezy' ||
                              method.ProviderType === 'iTransact'
                                ? 'Card or ACH'
                                : method.ProviderType === 'paypal'
                                ? 'Credit or Debit Card'
                                : method.ProviderType === 'accessIDLOC'
                                ? 'Access Idaho'
                                : method.ProviderType === 'frequentPayor'
                                ? 'Frequent Payor'
                                : method.ProviderType === 'bypass'
                                ? 'Bypass Checkout (Dev-only)'
                                : method.ProviderType,
                            value: method.ProviderType,
                          }))}
                        onChange={(methodType) => {
                          this.setState({
                            selectedMethod: availableMethods.find((method) => method.ProviderType === methodType),
                          })
                        }}
                      />
                      {this.state.selectedMethod && getPaymentMethodsJSX(this.state.selectedMethod)}
                    </div>
                  ) : (
                    availableMethods.map((method, i) => {
                      if (method.DisabledErrorMessage === null || ignoreAvailability) {
                        return getPaymentMethodsJSX(method)
                      } else {
                        return (
                          <p key={i} className="method-error">
                            {method.DisabledErrorMessage}
                          </p>
                        )
                      }
                    })
                  )
                ) : (
                  <p className="method-error">
                    There are currently no online payment methods available.
                  </p>
                )
              ) : null}
              {displayShoppingCart && hasRenderableItems ? (
                <div className="flex-row continue-section">
                  <button
                    className="continue-button"
                    disabled={paymentButtonsDisabled}
                    onClick={!this.state.paymentClicked ? onRequestModalClose : null}
                  >
                    <div className="flex-center">
                      <CaretLeftIcon /> File/Order Additional Items
                    </div>
                  </button>
                </div>
              ) : null}
            </React.Fragment>
          </NativeCheckout>
        )}
        <Portal isOpened={this.state.isCCPIFrameOpened}>
          <Modal
            title="Enter Payment Information"
            modalSize="extra-large"
            cancelButton={!this.state.ccpPaymentButtonClicked}
            closeModal={() =>
              this.setState({
                isCCPIFrameOpened: false,
                paymentClicked: false,
                loading: false,
              })
            }
          >
            {!this.state.ccpPaymentButtonClicked ? (
              <iframe
                src={this.state.iFrameSource}
                height="100%"
                width="100%"
                border="none"
                ref={this.iFrameRef}
              ></iframe>
            ) : (
              <React.Fragment>
                <div className='ccpPaymentButtonLoader'>
                  <div>Payment submitted, please wait...</div>
                  <Spinner className="loader" size="large" />
                </div>
              </React.Fragment>
            )}
          </Modal>
        </Portal>
      </div>
    )
  }
}
Checkout = connect(
  (state) => ({ isFrequentPayor: state.auth.isFrequentPayor, loggedIn: state.auth.loggedIn }),
  {
    setCartQuantity,
  }
)(Checkout)

const ItemContainer = ({ mainItem = {}, receiptItems, onRemoveRequested, disabled }) => {
  return (
    <div className="flex-row align-center line-item-container">
      <div className="buttons-wrapper">
        <button
          disabled={disabled}
          className="remove-item-button"
          onClick={onRemoveRequested}
          aria-label={`Remove ${
            mainItem.DESCR_DISPLAY ? mainItem.DESCR_DISPLAY : mainItem.DESCR
          } from the cart.`}
        >
          <CrossIcon />
        </button>
      </div>
      <div className="flex-column line-item-column">
        <LineItem
          product={mainItem.DESCR_DISPLAY ? mainItem.DESCR_DISPLAY : mainItem.DESCR}
          price={Number(mainItem.LINE_TOTAL).toFixed(2)}
          deletable
        />
        {receiptItems.map((item, i) => (
          <LineItem
            product={item.DESCR_DISPLAY ? item.DESCR_DISPLAY : item.DESCR}
            price={Number(item.LINE_TOTAL).toFixed(2)}
            key={item.REF_NUM.toString() + i}
            deletable
            subline
          />
        ))}
      </div>
    </div>
  )
}

const LineItem = ({ product, price, details = [], deletable, subline }) => (
  <div className={`line-item ${subline ? 'subline' : ''}`}>
    <div className="row">
      <div className="col-9">
        <span className={`product ${deletable ? 'deletable' : ''}`}>{product}</span>
        {details.map((detail, i) => (
          <span className="detail" key={i}>
            {detail}
          </span>
        ))}
      </div>
      <div className="col-3">
        <span className="price">${price}</span>
      </div>
    </div>
  </div>
)

const SubTotal = ({ label, price, total }) => (
  <div className={'row subtotal ' + (total ? 'total' : '')}>
    <div className="col-8">
      <span className="label">{label}</span>
    </div>
    <div className="col-4">
      <span className="price">{price}</span>
    </div>
  </div>
)

export class PaymentButton extends Component {
  state = {
    loading: false,
    error: false,
  }
  componentDidUpdate = (prevProps) => {
    if (prevProps.loading && this.props.loading && this.state.loading) {
      this.setState({ loading: false })
    }
    if (this.state.loading && this.props.error) {
      this.setState({
        loading: false,
        error: true,
      })
    }
  }
  onClick = () => {
    if (!this.props.bypassLoadingStyles) {
      this.setState({
        loading: true,
        error: false,
      })
    }
    this.props.onClick()
  }

  render() {
    const {
      children,
      disabled,
      loading,
      disableErrorHandling,
      forceShowError,
      className = '',
      style,
      icon,
    } = this.props
    const hasError = forceShowError || this.state.error

    return (
      <button
        type="button"
        className={`payment-button btn-3d button ${
          hasError && !disableErrorHandling ? 'danger' : ''
        } ${disabled === false ? '' : 'disabled'} ${className}`}
        onClick={this.onClick}
        disabled={disabled || (hasError && !disableErrorHandling)}
        style={style}
        aria-busy={(loading || this.state.loading) && !forceShowError}
      >
        <div className="center">
          {(this.state.loading || loading) && !forceShowError ? (
            <Spinner className="loader" size="small" linear color="currentColor" />
          ) : hasError && !disableErrorHandling ? (
            <CrossIcon />
          ) : icon ? (
            icon
          ) : (
            <LockIcon />
          )}
          <span className="label">
            {hasError && !disableErrorHandling ? 'Something went wrong' : children}
          </span>
          {(loading || this.state.loading) && (
            <span role="alert" className="visually-hidden">
              "Your payment is processing, please wait."
            </span>
          )}
        </div>
      </button>
    )
  }
}

class ITransact extends React.Component {
  state = {
    loaded: false,
    token: null,
    customer: null,
    allowAddNewPaymentSource: true,
    selectedSource: '',
    deletingPaymentType: false,
    reloadingPayment: false,
    processingPayment: false,
    checkoutButtonText: '',
    modalTitle: '',
    modalDescr: '',
    additionalText: '',
    apiUsername: '',
    achEnabled: false,
    error: null,
    description: null,
    skipStoredPayments: false,
  }
  script = null
  componentDidMount = () => {
    let promises = []
    if (!window.iTransact) {
      this.script = document.createElement('script')
      this.script.type = 'text/javascript'
      this.script.src = 'https://js.itransact.com/itransact.js'
      document.head.appendChild(this.script)
      promises.push(
        new Promise((resolve, reject) => {
          this.script.onload = (e) => {
            resolve()
          }
        })
      )
    }
    promises.push(
      new Promise((resolve, reject) => {
        GET_PAYROC_CUSTOMER(
          (customer) => {
            if (customer) {
              this.setState({
                customer,
                selectedSource: customer.payment_sources.length
                  ? customer.payment_sources[0].id
                  : '',
              })
            }
            resolve(customer)
          },
          (err) => {
            console.error(err)
            reject(err.message)
          }
        )
      })
    )
    promises.push(
      PASS_ITEM_GUIDS_ON_CHECKOUT
        ? new Promise((resolve, reject) => {
            GET_WEB_USER_ACTIVE_CART(
              (cart) => {
                if (cart) {
                  this.setState({
                    checkoutButtonText: cart.WEB_CART_ADDITIONAL_PROPS.CHECKOUT_BUTTON_TEXT
                      ? cart.WEB_CART_ADDITIONAL_PROPS.CHECKOUT_BUTTON_TEXT
                      : 'Continue',
                    modalTitle: cart.WEB_CART_ADDITIONAL_PROPS.MODAL_TITLE
                      ? cart.WEB_CART_ADDITIONAL_PROPS.MODAL_TITLE
                      : 'Checkout',
                    modalDescr: cart.WEB_CART_ADDITIONAL_PROPS.MODAL_DESCR
                      ? cart.WEB_CART_ADDITIONAL_PROPS.MODAL_DESCR
                      : 'Enter billing address and payment information to proceed',
                    achEnabled: cart.WEB_CART_ADDITIONAL_PROPS.ACH_ENABLED_YN,
                    additionalText: cart.WEB_CART_ADDITIONAL_PROPS.CHECKOUT_SLIDER_ADDITIONAL_TEXT,
                    description: cart.WEB_CART_ADDITIONAL_PROPS.ITRANSACT_DESCRIPTION || null,
                    skipStoredPayments:
                      cart.WEB_CART_ADDITIONAL_PROPS.SKIP_STORED_PAYMENTS || false,
                  })
                }
                resolve(cart)
              },
              (err) => {
                console.error(err)
                reject(err.message)
              }
            )
          })
        : new Promise((resolve, reject) => {
            GET_WEB_CART_BY_REF_NUM(
              this.props.refNum,
              (cart) => {
                if (cart) {
                  this.setState({
                    checkoutButtonText: cart.WEB_CART_ADDITIONAL_PROPS.CHECKOUT_BUTTON_TEXT
                      ? cart.WEB_CART_ADDITIONAL_PROPS.CHECKOUT_BUTTON_TEXT
                      : 'Continue',
                    modalTitle: cart.WEB_CART_ADDITIONAL_PROPS.MODAL_TITLE
                      ? cart.WEB_CART_ADDITIONAL_PROPS.MODAL_TITLE
                      : 'Checkout',
                    modalDescr: cart.WEB_CART_ADDITIONAL_PROPS.MODAL_DESCR
                      ? cart.WEB_CART_ADDITIONAL_PROPS.MODAL_DESCR
                      : 'Enter billing address and payment information to proceed',
                    achEnabled: cart.WEB_CART_ADDITIONAL_PROPS.ACH_ENABLED_YN,
                    additionalText: cart.WEB_CART_ADDITIONAL_PROPS.CHECKOUT_SLIDER_ADDITIONAL_TEXT,
                    description: cart.WEB_CART_ADDITIONAL_PROPS.ITRANSACT_DESCRIPTION || null,
                    skipStoredPayments:
                      cart.WEB_CART_ADDITIONAL_PROPS.SKIP_STORED_PAYMENTS || false,
                  })
                }
                resolve(cart)
              },
              (err) => {
                console.error(err)
                reject(err.message)
              }
            )
          })
    )
    promises.push(
      new Promise((resolve, reject) => {
        GET_APP_SETTING_BY_NAME(
          'PAYROC_API_USERNAME',
          (setting) => {
            if (setting) {
              this.setState({
                apiUsername: setting.VALUE,
              })
            }
            resolve(setting)
          },
          (err) => {
            console.error(err)
            reject(err.message)
          }
        )
      })
    )
    Promise.all(promises)
      .then(() => {
        this.setState({ loaded: true })
      })
      .catch((err) => {
        this.setState({ error: err })
      })
  }
  openItransact = () => {
    if (!this.state.error) this.setState({ error: null })
    const handler = window.iTransact.Checkout.init({
      apiUsername: this.state.apiUsername,
      name: this.state.modalTitle,
      description: this.state.modalDescr,
      panelButtonText: this.state.checkoutButtonText,
      billingAddress: true,
      ach: this.state.achEnabled,
      onToken: (data, args) => {
        this.setState({ token: data.token, reloadingPayment: true })
        CREATE_PAYROC_CUSTOMER_PAYMENT_SOURCE(
          {
            token: data.token,
            address: args,
          },
          (result) => {
            if (this.state.skipStoredPayments) {
              this.startTransaction(result.payment_sources[0].id, result.id)
            } else {
              if (result) {
                GET_PAYROC_CUSTOMER(
                  (customer) => {
                    if (customer) {
                      this.setState({
                        customer,
                        reloadingPayment: false,
                        selectedSource:
                          (customer.payment_sources[customer.payment_sources.length - 1] || {})
                            .id || '',
                      })
                    }
                  },
                  (err) => {
                    console.error(err)
                    this.setState({ reloadingPayment: false, error: err.message })
                  }
                )
              }
            }
          }
        )
      },
    })
    handler.render({
      amount: this.props.amount,
    })
  }
  startTransaction = (cardId, customerId) => {
    this.setState({ error: null, processingPayment: true })
    CREATE_PAYROC_TRANSACTION(
      {
        id: cardId,
        customerId,
        ITEMIDS: this.props.receiptItemGuids,
        REF_NUM: this.props.refNum,
      },
      (success) => {
        if (success) {
          this.props.onComplete(PASS_ITEM_GUIDS_ON_CHECKOUT ? success : null)
        }
      },
      (err) => {
        console.error(err)
        this.setState({ error: err.message, processingPayment: false })
      }
    )
  }
  startDelete = (id) => {
    this.setState({ deletingId: id })
    this.toggleDeleting()
  }
  deletePaymentType = () => {
    DELETE_PAYROC_CUSTOMER_PAYMENT_SOURCE(
      this.state.deletingId,
      () => {
        this.setState((state) => {
          const index = state.customer.payment_sources.findIndex((s) => state.deletingId === s.id)
          return {
            customer: {
              ...state.customer,
              payment_sources: [
                ...state.customer.payment_sources.slice(0, index),
                ...state.customer.payment_sources.slice(index + 1),
              ],
            },
            selectedSource: state.selectedSource === state.deletingId ? '' : state.selectedSource,
          }
        })
      },
      (err) => {
        console.error(err)
        this.setState({ error: err.message })
      }
    )
  }
  toggleDeleting = () => this.setState((s) => ({ deletingPaymentType: !s.deletingPaymentType }))
  render() {
    return (
      <div className="itransact-checkout">
        {this.state.loaded ? (
          <React.Fragment>
            {this.state.customer && !this.state.skipStoredPayments && (
              <React.Fragment>
                <div className="wizard">
                  <RadioInput
                    label={
                      this.state.additionalText || 'Select or add a payment method to checkout.'
                    }
                    ownsLabel
                    value={this.state.selectedSource}
                    onChange={(selectedSource) => this.setState({ selectedSource })}
                    options={this.state.customer.payment_sources.map((source) => ({
                      value: source.id,
                      label:
                        source.type === 'ach' ? (
                          <span className="label-wrapper">
                            <BankIcon />
                            {`${source.savings_account === 'true' ? 'Savings' : 'Checking'} ****${
                              source.last_four_digits
                            }`}
                            <button
                              className="trash-button"
                              type="button"
                              onClick={() => this.startDelete(source.id)}
                              disabled={this.state.processingPayment}
                            >
                              <TrashIcon />
                            </button>
                          </span>
                        ) : (
                          <span className="label-wrapper">
                            <CreditCardIcon alt='Credit Card icon' />
                            {`${source.brand.charAt(0).toUpperCase() + source.brand.slice(1)} ****${
                              source.last_four_digits
                            }`}
                            <button
                              className="trash-button"
                              type="button"
                              onClick={() => this.startDelete(source.id)}
                              disabled={this.state.processingPayment}
                            >
                              <TrashIcon />
                            </button>
                          </span>
                        ),
                    }))}
                  />
                </div>
              </React.Fragment>
            )}
            {!this.state.skipStoredPayments && (
              <button
                type="button"
                className="new-payment-btn"
                disabled={this.state.reloadingPayment || this.state.processingPayment}
                onClick={this.openItransact}
              >
                <div className="flex-center">
                  {this.state.reloadingPayment ? (
                    <React.Fragment>
                      <Spinner size="small" color="rgba(255,255,255,.6)" /> Adding Payment Method
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <PlusIcon /> Add New Payment Method
                    </React.Fragment>
                  )}
                </div>
              </button>
            )}
            {this.state.error && (
              <p className="payment-error" role="alert">
                <CrossIcon /> <span>{this.state.error}</span>
              </p>
            )}
            {(this.state.selectedSource || this.state.skipStoredPayments) && (
              <PaymentButton
                onClick={() =>
                  this.state.skipStoredPayments
                    ? this.openItransact()
                    : this.startTransaction(this.state.selectedSource)
                }
                disabled={
                  !this.state.loaded ||
                  (!this.state.selectedSource && !this.state.skipStoredPayments) ||
                  this.state.processingPayment
                }
                error={this.state.prePaymentError}
                disableErrorHandling={true}
                bypassLoadingStyles={true}
                loading={this.state.processingPayment}
              >
                Checkout
              </PaymentButton>
            )}
            {this.state.description && (
              <ReactMarkdown
                source={this.state.description}
                className="markdown cart-description"
              />
            )}
            {CHECKOUT_DISCLAIMER && (
              <ReactMarkdown source={CHECKOUT_DISCLAIMER} className="markdown" />
            )}
          </React.Fragment>
        ) : (
          <Spinner color="#7792d0" className="checkout-loader" size="small" />
        )}
        <Portal isOpened={this.state.deletingPaymentType}>
          <ConfirmDialog
            closeModal={this.toggleDeleting}
            onModalClosed={() => {}}
            message="Are you sure you want to delete this payment method? Any active subscriptions using this payment method will be canceled. This cannot be undone."
            buttons={[
              { label: 'No', onClick: () => {}, className: 'btn-default' },
              {
                label: 'Yes',
                onClick: this.deletePaymentType,
                className: 'btn-danger',
              },
            ]}
            modalStyle={{ borderRadius: 3 }}
          />
        </Portal>
      </div>
    )
  }
}
